import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Encabezado.css";
import MenuHamburguesa from "../MenuHamburguesa/MenuHamburguesa.jsx";

function Encabezado({ navSections }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
   <div className={`Encabezado ${scrolled ? "scrolled" : ""}`}>
      <div className="menu-container">
        <MenuHamburguesa isOpen={isMenuOpen} toggleMenu={toggleMenu} />

        <div className={`navWrapper ${isMenuOpen ? "open" : ""}`}>
          <div className="navLinks">
            {navSections.map((section, index) => (
              <button
                key={index}
                onClick={() => scrollToSection(section.ref)}
                className="nav-button"
              >
                {section.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <Link to={"/"} id="nombre-Encabezado">
        <p id="cogote-Encabezado">
          COGOTE | <span id="churrascaria-Encabezado">CHURRASCARIA</span>
        </p>
        {/* <img src="/Assets/COGOTE LOGO WHITE.png" id="logo-Encabezado" alt="Cogote Churrascria"/> */}
      </Link>

      <a href="https://wa.me/5219331194137" target="blank" id="reservar-Encabezado">
        RESERVAR
      </a>
    </div>
  );
}

export default Encabezado;
